const DEFAULT_FORM_INPUT_LABEL_CLASS_NAME = 'form-input-label';
const ONBOARDING_INPUT_LABEL_CLASS_NAME = 'onboarding-input-label';
const LARGE_INPUT_LABEL_CLASS_NAME = 'large-input-label';

export {
  DEFAULT_FORM_INPUT_LABEL_CLASS_NAME,
  ONBOARDING_INPUT_LABEL_CLASS_NAME,
  LARGE_INPUT_LABEL_CLASS_NAME,
};
